import { useState } from "react";
import PersonalDetails from "./CrmPlayerPersonalDetailsTab";
import Gifts from "./CrmGiftsTab";
import Feedback from "./CrmFeedbackTab";
import SocialMedia from "./CrmSocialMediaTab";
import Referrals from "./CrmReferalsTab";
import Flag from "./CrmFlagTab";

const PlayerDetails = ({ player, onClose }) => {
  const [activeTab, setActiveTab] = useState("personal-details");

  // Styles
  const modalStyle = {
    backgroundColor: "#fff", // White background for the modal
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    marginTop: "10px",
    padding: "10px",
  };

  const headerStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#144d56", // Deep teal for the header
    marginBottom: "20px",
  };

  const tabsStyle = {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
    flexWrap: "wrap", // Allow tabs to wrap on smaller screens
  };

  const tabButtonStyle = (tab) => ({
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    backgroundColor: activeTab === tab ? "#50868f" : "#e5efe4", // Active tab: muted teal, Inactive tab: soft green
    color: activeTab === tab ? "#fff" : "#333",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s, color 0.3s",
  });

  const tabContentStyle = {
    padding: "20px",
    borderTop: "1px solid #e5efe4", // Soft green border
  };

  const closeButtonStyle = {
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    backgroundColor: "#50868f", // Muted teal for the close button
    color: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    marginTop: "20px",
    transition: "background-color 0.3s",
  };

  const closeButtonHoverStyle = {
    backgroundColor: "#5f9aa3", // Slightly lighter teal for hover
  };

  return (
    <div style={modalStyle}>
      <h2 style={headerStyle}>{player.name}</h2>
      <div style={tabsStyle}>
        <button
          style={tabButtonStyle("personal-details")}
          onClick={() => setActiveTab("personal-details")}
        >
          Personal Details
        </button>
        <button
          style={tabButtonStyle("gifts")}
          onClick={() => setActiveTab("gifts")}
        >
          Gifts
        </button>
        <button
          style={tabButtonStyle("feedback")}
          onClick={() => setActiveTab("feedback")}
        >
          Feedback
        </button>
        <button
          style={tabButtonStyle("social-media")}
          onClick={() => setActiveTab("social-media")}
        >
          Social Media
        </button>
        <button
          style={tabButtonStyle("referrals")}
          onClick={() => setActiveTab("referrals")}
        >
          User Referrals
        </button>
        <button
          style={tabButtonStyle("flag")}
          onClick={() => setActiveTab("flag")}
        >
          Review
        </button>
      </div>
      <div style={tabContentStyle}>
        {activeTab === "personal-details" && (
          <PersonalDetails player={player} />
        )}
        {activeTab === "gifts" && <Gifts player={player} />}
        {activeTab === "feedback" && <Feedback player={player} />}
        {activeTab === "social-media" && <SocialMedia player={player} />}
        {activeTab === "referrals" && <Referrals player={player} />}
        {activeTab === "flag" && <Flag player={player} />}
      </div>
      {/* <button
        style={closeButtonStyle}
        onClick={onClose}
        onMouseEnter={(e) => (e.target.style.backgroundColor = closeButtonHoverStyle.backgroundColor)}
        onMouseLeave={(e) => (e.target.style.backgroundColor = closeButtonStyle.backgroundColor)}
      >
        Close
      </button> */}
    </div>
  );
};

export default PlayerDetails;
